export default __webpack_public_path__ + "static/media/Vladimir.c3285673.ttf";